<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from 'echarts'
// require('echarts/theme/macarons') // echarts theme
import resize from './resize'
import { getDateAndHour, updateTime, howLongAgo, getDateAndWeek } from '@/utils/updateTime.js'
import store from '@/store'
import { temChange, temUnit } from '@/utils/temChange.js'
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    sn: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '300px'
    },
    lineChartData: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    lineChartData: {
      handler(newValue, oldValue) {
        this.lineChartData = newValue // 把新值赋值给我们的属性数据
        this.initChart() // 刷新echarts图表
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
    })
    setTimeout(() => {
      this.initChart()
    }, 500)
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
    // 组件销毁前移除监听
    window.removeEventListener('resize', this.resizePerformanceFun)
  },
  methods: {
    initChart() {
      if (this.chart) {
        this.chart.clear()
      }
      var sn = this.sn
      this.chart = echarts.init(this.$el)
      var secondLegend = []
      var legendselectHiden = {}
      secondLegend = ['Ignit(V)', 'HourMeter(V)', 'Aux.Volt(-V)', 'Aux.Cha(A)', 'Aux.Dis(A)', 'Aux.Soc(%)']
      legendselectHiden = { 'Ignit(V)': false, 'HourMeter(V)': false, 'Aux.Volt(-V)': false, 'Aux.Volt(+V)': false, 'Aux.Cha(A)': false, 'Aux.Dis(A)': false, 'Aux.Soc(%)': false }

      var temType = store.state.temType || 'ssd'
      var tem = 'Temp.(℃)'
      if (temType != 'ssd') { // 华氏度
        tem = 'Temp.(℉)'
      } else {
        tem = 'Temp.(℃)'
      }
      var option = {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          formatter: function(params, ticket, callback) {
            var htmlStr = ''
            var timeP = '<p>' + params[0] ? getDateAndHour(params[0].axisValue, '') : '' + '</p>'
            for (var j = 0; j < params.length; j++) {
              var param = params[j]
              var seriesName = param ? param.seriesName : ''// 图例名称
              var color = param ? param.color : ''// 图例颜色
              var value = param ? param.data[1] : ''

              htmlStr += '<div>'
              // 圆点
              htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' + color + ';"></span>'
              if (param) {
                // 圆点后面显示的文本
                htmlStr += seriesName + '：' + value
              }
              htmlStr += '</div>'
            }
            var result = '<p>' + sn + '</p>' + timeP + htmlStr
            return result
          }
        },
        legend: [{
          // icon: 'rect',
          itemWidth: 12,
          itemHeight: 12,
          data: ['Cha.(Ah)', 'Dis.(Ah)', 'Volt(V)', tem, 'SOC(%)', 'accelX', 'accelY', 'accelZ', 'yaw', 'roll', 'pitch'],
          selected: {// 默认不展示
            // 'SOC(%)': false,
            // 'Temp.(℃)': false
          }
        }],
        grid: {},
        xAxis: {
          type: 'time',
          showAllSymbol: true,
          splitLine: {
            show: false
          },
          axisLabel: {
            formatter: function(value, index) {
              return new Date(value).toLocaleDateString()
            }
          },
          zlevel: 1

        },
        yAxis: [
          {
            axisLine: {
              lineStyle: { color: '#2B2B2B' }
            },
            splitLine: { show: false },
            scale: true,
            type: 'value',
            name: 'Ah',
            position: 'left'
          },
          {
            axisLine: {
              lineStyle: { color: '#8e038b' }
            },
            offset: 40,
            splitLine: { show: false },
            type: 'value',
            name: 'V',
            position: 'left',
            axisTick: { inside: 'false' }
          },
          {
            axisLine: {
              lineStyle: { color: '#0e8dcd' }
            },
            splitLine: { show: false },
            type: 'value',
            name: temUnit(),
            position: 'right',
            // boundaryGap: [0, '100%'],
            axisTick: { inside: 'false', length: 10 }
          },
          {
            axisLine: {
              lineStyle: { color: '#298E09' }
            },
            splitLine: { show: false },
            offset: 40,
            type: 'value',
            name: '%',
            position: 'right',
            // boundaryGap: [0, '100%'],
            axisTick: { inside: 'false', length: 10 }
          },
          {
            axisLine: {
              lineStyle: { color: '#0e8dcd' }
            },
            splitLine: { show: false }
          }
        ],

        dataZoom: [{
          show: true,
          realtime: true,
          start: 0,
          end: 100,
          textStyle: { color: '#A5D239' }
        }, {
          type: 'inside',
          realtime: true,
          start: 0,
          end: 100
        }],

        color: ['#324CD2', '#ffabac', '#8e038b', '#0e8dcd', '#298E09', '#324CD2', '#FFCC00', '#996666', '#cc6699', '#339999', '#9966cc', '#6699cc', '#ff9933', '#cc6666', '#666699'], // 在这里设置colorList，是一个数组，图片颜色会按顺序选取
        series: [
          {
            name: 'Cha.(Ah)',
            type: 'line',
            data: this.lineChartData.d3,
            symbol: 'none',
            tooltip: { trigger: 'axis' },
            // smooth: true,
            yAxisIndex: 0
          },
          {
            name: 'Dis.(Ah)',
            type: 'line',
            data: this.lineChartData.d4,
            symbol: 'none',
            tooltip: { trigger: 'axis' },
            // smooth: true,
            yAxisIndex: 0,
            itemStyle: { normal: { label: { show: true, position: 'left' }}}
          },

          {
            name: 'Volt(V)',
            type: 'line',
            symbol: 'none',
            showAllSymbol: true,
            data: this.lineChartData.d5,
            tooltip: { trigger: 'axis' },
            // smooth: true,
            yAxisIndex: 1,
            itemStyle: { normal: { label: { show: true, position: 'left' }}}
          },
          {
            name: tem,
            type: 'line',
            tooltip: { trigger: 'axis' },
            symbol: 'none',
            data: this.lineChartData.d6,
            yAxisIndex: 4
          },
          {
            name: 'SOC(%)',
            type: 'line',
            tooltip: { trigger: 'axis' },
            symbol: 'none',
            data: this.lineChartData.d7,
            yAxisIndex: 3
          },
          {
            name: 'accelX',
            type: 'line',
            tooltip: { trigger: 'axis' },
            symbol: 'none',
            data: this.lineChartData.d8,
            yAxisIndex: 3
          },
          {
            name: 'accelY',
            type: 'line',
            tooltip: { trigger: 'axis' },
            symbol: 'none',
            data: this.lineChartData.d9,
            yAxisIndex: 3
          },
          {
            name: 'accelZ',
            type: 'line',
            tooltip: { trigger: 'axis' },
            symbol: 'none',
            data: this.lineChartData.d10,
            yAxisIndex: 3
          },
          {
            name: 'yaw',
            type: 'line',
            tooltip: { trigger: 'axis' },
            symbol: 'none',
            data: this.lineChartData.d11,
            yAxisIndex: 3
          },
          {
            name: 'roll',
            type: 'line',
            tooltip: { trigger: 'axis' },
            symbol: 'none',
            data: this.lineChartData.d12,
            yAxisIndex: 3
          },
          {
            name: 'pitch',
            type: 'line',
            tooltip: { trigger: 'axis' },
            symbol: 'none',
            data: this.lineChartData.d13,
            yAxisIndex: 3
          }
        ]
      }
      this.chart.setOption(option, true)
      //  监听窗口大小改变图表大小（先移除再监听，防止出错）
      window.removeEventListener('resize', this.resizePerformanceFun)
      window.addEventListener('resize', this.resizePerformanceFun)
    },
    resizePerformanceFun() {
      if (this.chart) {
        // console.log('窗口改变了，重新渲染图形')
        this.chart.resize()
      }
    }
  }
}
</script>
